import React, { useCallback } from "react";
import { Button, Textarea } from "@/components/ui";
import { SubscribedPlayerSearchResponse } from "@/interfaces";
import { PlayersServices } from "@/services";
import { FormCard } from "@/components/FormCard";
import { toast } from "sonner";

interface Props {
  player: SubscribedPlayerSearchResponse;
  reloadPlayer: () => void;
  clearCaches: () => void;
}

export function PlayerComplianceForm({ player, reloadPlayer, clearCaches }: Props) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [complianceDisclaimer, setComplianceDisclaimer] = React.useState<string | undefined>(
    player.playerAccount.complianceDisclaimer
  );

  const updateComplianceDisclaimer = useCallback((): void => {
    if (complianceDisclaimer !== player.playerAccount.complianceDisclaimer) {
      setLoading(true);
      PlayersServices.updatePlayerProfile(player.playerAccount.playerId!, {
        complianceDisclaimer,
      })
        .catch((e: string) => {
          toast.error(e.substring(0, 40));
        })
        .then(() => {
          clearCaches();
          reloadPlayer();
          toast.success("Compliance disclaimer updated!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    complianceDisclaimer,
    setLoading,
    clearCaches,
    player.playerAccount.complianceDisclaimer,
    player.playerAccount.playerId,
    reloadPlayer,
  ]);

  return (
    <FormCard>
      <FormCard.Header
        title={"Compliance Disclaimer"}
        description={"Automatically appended to eligible posts based on your compliance settings"}
      />
      <FormCard.Content>
        <Textarea
          id={"complianceDisclaimer"}
          placeholder={"Compliance Disclaimer"}
          onChange={e => {
            setComplianceDisclaimer(e.currentTarget.value);
          }}
          value={complianceDisclaimer}
        />
      </FormCard.Content>
      <FormCard.Actions>
        <Button onClick={updateComplianceDisclaimer} disabled={loading} loading={loading}>
          Save
        </Button>
      </FormCard.Actions>
    </FormCard>
  );
}
